import React from "react";
import { Alert } from "antd";

const RequestError = () => {
  return (
    <Alert
      style={{ marginBottom: "5px", marginTop: "5px" }}
      type="warning"
      message="Data request(s) failed"
      showIcon={true}
      description="One or more requests to get data failed. Please re-run report, if error persists, contact pdView."
    />
  );
};

export default RequestError;



// WEBPACK FOOTER //
// ./src/views/components/request_error/RequestError.jsx